import React from 'react';
import { observer } from 'mobx-react-lite';
import IMQAddEmployeesPageStore, {
  IMQAddEmployeesPageStoreContext,
} from 'store/pages/quote/imq-add-employees/pageStore';
import { PageContent } from 'components/quote/imq-add-employees';
import { useQuoteDomainParams } from 'global/hooks/useQuoteDomainParams';

/* TESTING_POLICY: CYPRESS_ONLY */

const IMQAddEmployeesPage: React.FC = observer(() => {
  const domainParams = useQuoteDomainParams();

  return (
    <IMQAddEmployeesPageStoreContext.Provider value={new IMQAddEmployeesPageStore(domainParams)}>
      <PageContent />
    </IMQAddEmployeesPageStoreContext.Provider>
  );
});

export default IMQAddEmployeesPage;
